import { HOURS } from "../data/restaurant";

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
    {HOURS.map((h) => (
      <span key={h.day} className="flex items-center">
        <span className="whitespace-nowrap px-5 font-display text-lg font-black uppercase tracking-wide text-cream sm:text-xl">
          {h.day} <span className="text-sunshine">{h.time}</span>
        </span>
        <svg viewBox="0 0 24 24" className="h-5 w-5 shrink-0 fill-sunshine" aria-hidden="true">
          <path d="M12 0l2.6 8.4L24 12l-9.4 3.6L12 24l-2.6-8.4L0 12l9.4-3.6z" />
        </svg>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="relative z-10 -my-5 overflow-hidden py-5" data-testid="marquee-strip">
      <div className="-rotate-1 scale-x-[1.03] border-y-4 border-jet bg-crimson py-4 shadow-hard">
        <div className="flex w-max animate-marquee">
          <Row />
          <Row hidden />
        </div>
      </div>
    </div>
  );
}
